// extracted by mini-css-extract-plugin
module.exports = {"global-site-options":"GlobalSiteOptions_global-site-options__3jp9m"};